export default __webpack_public_path__ + "f71f2288b959243b0ed1eeea6bc97222.ttf";